import { multiFilter } from "@homebound/beam";
import { useUseRoomTypeFilterQuery } from "src/components/autoPopulateFilters/useRoomTypeFilter.generated";

export function useRoomTypeFilter() {
  const { data } = useUseRoomTypeFilterQuery({ fetchPolicy: "cache-first" });
  return multiFilter({
    label: "Room Type",
    options: data?.roomTypes ?? [],
    getOptionLabel: ({ name }) => name,
    getOptionValue: ({ id }) => id,
  });
}
